export default {
  '1': 'Primera cuota',
  '2': 'Segunda cuota',
  'T': 'Pago total'
}
